<template>
  <div>
    <h2>View/Edit Advertisment Id: {{ adId }}</h2>
    <table v-if="advertisment" class="table table-striped table-sm">
      <thead></thead>
      <tbody>
        <tr>
          <td>Name</td>
          <td>{{ advertisment.name }}</td>
        </tr>
        <tr>
          <td>Email</td>
          <td>{{ advertisment.email }}</td>
        </tr>
        <tr>
          <td>Men Recipients Number</td>
          <td>{{ advertisment.menRecipientsNumber }}</td>
        </tr>
        <tr>
          <td>Women Recipients Number</td>
          <td>{{ advertisment.womenRecipientsNumber }}</td>
        </tr>
        <tr>
          <td>Price</td>
          <td>{{ advertisment.price }}</td>
        </tr>
        <tr>
          <td>Updated At</td>
          <td>{{ advertisment.updatedAt }}</td>
        </tr>
        <tr>
          <td>Approved</td>
          <td>
            <div v-if="advertisment.approved">Yes</div>
            <div v-if="!advertisment.approved">
              <b-button size="sm" variant="success" @click="approve"
                >Approve</b-button
              >
            </div>
          </td>
        </tr>
        <tr>
          <td>Pushes count</td>
          <td>
            <div v-if="advertisment.approved">
              {{
                advertisment.menRecipientsNumber +
                  advertisment.womenRecipientsNumber
              }}
            </div>
            <div v-if="!advertisment.approved">0</div>
          </td>
        </tr>
      </tbody>
    </table>
    <img :src="photoPreview" />
    <b-form v-if="advertisment" @submit="onSubmit">
      <b-form-group
        id="titleLabel"
        label="Title:"
        label-for="title"
        description=""
      >
        <b-form-input
          id="title"
          v-model="advertisment.advertisment.title"
          type="text"
          required
          placeholder="Enter title"
        />
      </b-form-group>
      <b-form-group
        id="textLabel"
        label="Text:"
        label-for="text"
        description=""
      >
        <b-form-input
          id="text"
          v-model="advertisment.advertisment.text"
          type="text"
          required
          placeholder="Enter text"
        />
      </b-form-group>
      <b-form-group
        id="aEventNameLabel"
        label="Advertiser/Event name:"
        label-for="aEventName"
        description=""
      >
        <b-form-input
          id="aEventName"
          v-model="advertisment.advertisment.aEventName"
          type="text"
          placeholder="Enter Advertiser/Event name"
        />
      </b-form-group>
      <b-form-group
        id="streetLabel"
        label="Street:"
        label-for="street"
        description=""
      >
        <b-form-input
          id="street"
          v-model="advertisment.advertisment.aRedeemAddress.street"
          type="text"
          placeholder="Enter Street"
        />
      </b-form-group>
      <b-form-group
        id="cityLabel"
        label="City:"
        label-for="city"
        description=""
      >
        <b-form-input
          id="city"
          v-model="advertisment.advertisment.aRedeemAddress.city"
          type="text"
          placeholder="Enter City"
        />
      </b-form-group>
      <b-form-group id="zipLabel" label="Zip:" label-for="zip" description="">
        <b-form-input
          id="zip"
          v-model="advertisment.advertisment.aRedeemAddress.zip"
          type="text"
          placeholder="Enter Zip"
        />
      </b-form-group>
      <b-form-group
        id="countryLabel"
        label="Country:"
        label-for="country"
        description=""
      >
        <b-form-input
          id="country"
          v-model="advertisment.advertisment.aRedeemAddress.country"
          type="text"
          placeholder="Enter Country"
        />
      </b-form-group>
      <b-button v-if="!advertisment.approved" type="submit" variant="primary"
        >Save</b-button
      >
    </b-form>
  </div>
</template>

<script>
import API from '@/api';
import Geocoder from '@/geocoder';

export default {
  name: 'AdvertismentEdit',
  data() {
    return {
      adId: this.$route.params.id,
      advertisment: null,
      photoPreview: null
    };
  },
  created() {
    API.post(`admin/advertising/item`, { id: this.adId }).then(res => {
      if (res.status === 'ok') {
        this.advertisment = res.data.advertising;
        this.photoPreview = res.data.photoPreview;
      }
    });
  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();
      console.log(123);
      if (
        this.advertisment.advertisment.aRedeemAddress.street !== '' ||
        this.advertisment.advertisment.aRedeemAddress.city !== '' ||
        this.advertisment.advertisment.aRedeemAddress.zip !== '' ||
        this.advertisment.advertisment.aRedeemAddress.country !== ''
      ) {
        let res = await Geocoder.requestLocationObj({
          address_line_1: this.advertisment.advertisment.aRedeemAddress.street,
          address_line_2: '',
          city: this.advertisment.advertisment.aRedeemAddress.city,
          zip_code: this.advertisment.advertisment.aRedeemAddress.zip,
          country: this.advertisment.advertisment.aRedeemAddress.country
        });
        if (res.data) {
          res = res.data.result;
          this.advertisment.advertisment.aRedeemAddress.lat =
            res.geometry.location.lat;
          this.advertisment.advertisment.aRedeemAddress.lng =
            res.geometry.location.lng;
        } else {
          this.advertisment.advertisment.aRedeemAddress.lat = null;
          this.advertisment.advertisment.aRedeemAddress.lng = null;
        }
      } else {
        this.advertisment.advertisment.aRedeemAddress.lat = null;
        this.advertisment.advertisment.aRedeemAddress.lng = null;
      }
      API.post(`admin/advertising/update`, this.advertisment).then(res => {
        if (res.status === 'ok') {
          console.log(res);
        }
      });
    },
    approve() {
      API.post('admin/advertising/approve', this.advertisment).then(res => {
        if (res.status === 'ok') {
          this.advertisment = res.data.advertising;
        }
      });
    }
  }
};
</script>

<style scoped></style>
